export const sharingUnitTariffStatusFilter = {
  key: 'sharing_unit_tariff_statuses',
  query: 'statuses',
  isAvailable: () => true,
  aggregationKey: 'statuses',
};
